import React from 'react';
import './index.less';

function Footer() {
  return (
    <footer className="footer">
        <div className="footer-copy">
            <p>© All rights reserved by M.Emre Kılıç</p>
        </div>
    </footer>
  );
}

export default Footer;